import { RequestLocationProvider } from "../../../../components/requests/RequestLocationContext";
import { requestPayload, requestDestinationMessage } from "../../../../components/requests/requestLocationUtils";
import React from "react";
import ShiftPoolDisplay from "../ShiftPoolDisplay";
import TradesDisplay from "../TradesDisplay";
import AvailabilityDisplay from "../AvailabilityDisplay";
import TimeOffDisplay from "../TimeOffDisplay";
import { getBusinessWeekStartDayIndex } from "../../reporting/dateRangePresets";
import {
  API_get_weather,
  API_get_events,
  API_get_default_availability,
  API_list_availability_for_employee,
  API_list_availability_requests_for_manager,
  API_list_availability_request_responses_for_manager,
  // API_list_preferred_availability_for_employee,
  // API_list_preferred_availability_requests_for_manager,
  // API_list_preferred_availability_request_responses_for_manager,
  API_get_list_time_off_requests_for_manager,
  API_get_schedule,
  API_get_shift_pool_for_manager,
  API_get_list_users,
  API_drop_shift,
  API_rescind_drop_shift,
  API_pickup_shift,
  API_rescind_pickup_shift,
  API_manager_reject_shift_drop,
  API_manager_accept_shift_drop,
  API_manager_approve_shift_pickup,
  API_archive_shift_pickup_request,
  API_hide_shift_change_request,
  API_manager_shift_pickup_request_response,
  API_create_availability_request,
  API_rescind_availability_request,
  API_delete_availability_request,
  API_hide_availability_request,
  API_create_preferred_availability_request,
  API_rescind_preferred_availability_request,
  API_delete_preferred_availability_request,
  API_hide_preferred_availability_request,
  API_request_time_off,
  API_rescind_time_off_request,
  API_delete_time_off_request,
  API_hide_time_off_request,
  API_manager_respond_to_availability_request,
  API_manager_respond_to_preferred_availability_request,
  API_respond_to_time_off_request,
  API_drawer_notifications,
  API_hide_drawer_notification,
  API_hide_all_drawer_notifications,
  API_get_notification_settings,
  API_update_notification_settings,
  API_store_team_member_set_hide,
  API_store_team_member_set_order,
  API_get_roles,
  API_get_blackout_dates,
  API_create_blackout_date,
  API_delete_blackout_date,
  API_get_manager_shift_change_request_responses,
} from "../../../../constants";
import { getRightworkAPI } from "../utilities/requests";
import { postRightworkAPI } from "../utilities/requests";
import { formatDate, getMaxDatePlusOne } from "../utilities/helpers";
import NotificationsDrawer from "../NotificationsDrawer";
import WavesIcon from "@mui/icons-material/Waves";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import BackHandOutlinedIcon from "@mui/icons-material/BackHandOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadSpinner from "../../../../utilities/LoadSpinner";
import TopBarDisplayTitle from "../../home/top_bar_components/TopBarDisplayTitle";

export default function RequestsDisplay(props) {
  const [storeId, setStoreId] = React.useState(props.homeStore);
  React.useEffect(() => setStoreId(props.homeStore), [props.homeStore]);
  // const [storeName, setStoreName] = React.useState(store_name);

  const [data, setData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  const [display, setDisplay] = React.useState("Shift Pool");

  const [notificationsOpen, setNotificationsOpen] = React.useState(false);

  const storeTimezone = React.useMemo(() => {
    return props.storeNames?.find((store) => store.id === props.homeStore)?.timezone || null;
  }, [props.storeNames, props.homeStore]);

  function handleNotificationClick() {
    setNotificationsOpen((prevState) => !prevState);
  }

  const notificationsRef = React.useRef(null);

  React.useEffect(() => {
    const closeNotificationsOnOutsideClick = (event) => {
      if (
        notificationsOpen &&
        notificationsRef.current &&
        !notificationsRef.current.contains(event.target)
      ) {
        setNotificationsOpen(false);
      }
    };

    document.addEventListener("click", closeNotificationsOnOutsideClick);

    return () => {
      document.removeEventListener("click", closeNotificationsOnOutsideClick);
    };
  }, [notificationsOpen]);

  // Date range: today to 1 month out
  const currentDate = new Date();
  let lowerBoundDate = new Date(currentDate);
  lowerBoundDate.setDate(currentDate.getDate() - 1);
  let upperBoundDate = new Date(currentDate);
  upperBoundDate.setDate(currentDate.getDate() + 30);

  const api_params = {
    store_id: props.homeStore,
    lower_bound_date: formatDate(lowerBoundDate),
    upper_bound_date: formatDate(upperBoundDate),
    specific_date: formatDate(currentDate),
    date_start: formatDate(currentDate),
    date_end: formatDate(currentDate),
  };

  // Phase 1: Only what the default Shift Pool Requests tab needs
  const phase1_api_calls = {
    shiftPool: API_get_shift_pool_for_manager,
    roleNames: API_get_roles,
  };

  // Phase 2: Everything else, fetched in parallel
  const phase2_api_calls = {
    schedule: API_get_schedule,
    availability2: API_list_availability_for_employee,
    availabilityRequests: API_list_availability_requests_for_manager,
    availabilityRequestsResponses:
      API_list_availability_request_responses_for_manager,
    timeOff: API_get_list_time_off_requests_for_manager,
    requestResponsesv2: API_get_manager_shift_change_request_responses,
    notifications: API_drawer_notifications,
    notificationSettings: API_get_notification_settings,
    blackoutDates: API_get_blackout_dates,
  };

  const fetch_data = async (api_calls, api_params, showLoading) => {
    if (showLoading) setIsLoading(true);
    let api_set_data_name = Object.keys(api_calls);
    let api_list = Object.values(api_calls);
    try {
      const res = await Promise.all(
        api_list.map((api) => getRightworkAPI(api, api_params))
      );
      setData((prevData) => {
        const newData = { ...prevData };
        res.forEach((res, i) => (newData[api_set_data_name[i]] = res.data));
        return newData;
      });
      if (showLoading) setIsLoading(false);
    } catch (error) {
      if (showLoading) setIsLoading(false);
    }
  };

  // ----------- POST APIs ----------- //
  // const drop_shift = async (shift_drop_id, shift_pickup_id, drop_note) => {
  //   // Prepare data to send
  //   const requestData = {
  //     store_id: storeId,
  //     shift_drop_id: shift_drop_id,
  //     ...(shift_pickup_id && { shift_pickup_id: shift_pickup_id }),
  //     drop_note: drop_note
  //   };

  //   try {
  //     toast.loading("Submitting Add to Pool Request...", { autoClose: false });

  //     const res = await postRightworkAPI(API_drop_shift, requestData);

  //     if (res.status === 200) {
  //       toast.dismiss();
  //       toast.success("Add to Pool Request Submitted!", { autoClose: 3000 });

  //       fetch_data(
  //         {
  //           shiftPool: API_get_shift_pool_for_manager,
  //           schedule: API_get_schedule,
  //         },
  //         api_params
  //       );
  //     }
  //   } catch (error) {
  //     toast.dismiss();

  //     if (error.response?.data?.system?.message) {
  //       toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
  //     } else {
  //       toast.error("Request Failed", { autoClose: 3000 });
  //     }

  //     console.error("Error:", error); // Handle error as needed
  //   }
  // };

  // const rescind_drop_shift = async (shift_drop_id) => {
  //   // Prepare data to send
  //   const requestData = {
  //     store_id: storeId,
  //     shift_drop_id: shift_drop_id,
  //   };

  //   try {
  //     toast.loading("Cancelling Add to Pool Request...", { autoClose: false });

  //     const res = await postRightworkAPI(API_rescind_drop_shift, requestData);

  //     if (res && res.status === 200) {
  //       // Handle success
  //       toast.dismiss();
  //       toast.success("Add to Pool Request Cancelled!", { autoClose: 3000 });
  //       fetch_data(
  //         {
  //           shiftPool: API_get_shift_pool_for_manager,
  //           shiftPickupResponses:
  //             API_get_manager_shift_pickup_request_responses,
  //           schedule: API_get_schedule,
  //         },
  //         api_params
  //       );
  //     }
  //   } catch (error) {
  //     // Handle network error
  //     toast.dismiss();

  //     if (error.response?.data?.system?.message) {
  //       toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
  //     } else {
  //       toast.error("Request Failed", { autoClose: 3000 });
  //     }
  //     console.error("Error:", error); // Handle error as needed
  //   }
  // };

  // const trade_shift = async (shift_drop_id, shift_pickup_id) => {
  //   // Prepare data to send
  //   const requestData = {
  //     store_id: storeId,
  //     shift_drop_id: shift_drop_id,
  //     ...(shift_pickup_id && { shift_pickup_id: shift_pickup_id }),
  //   };

  //   try {
  //     toast.loading("Submitting Trade Request...", { autoClose: false });

  //     const res = await postRightworkAPI(API_drop_shift, requestData);

  //     if (res.status === 200) {
  //       toast.dismiss();
  //       toast.success("Trade Request Submitted!", { autoClose: 3000 });

  //       fetch_data(
  //         {
  //           shiftPool: API_get_shift_pool_for_manager,
  //           shiftPickupResponses:
  //             API_get_manager_shift_pickup_request_responses,
  //           schedule: API_get_schedule,
  //         },
  //         api_params
  //       );
  //     }
  //   } catch (error) {
  //     toast.dismiss();

  //     if (error.response?.data?.system?.message) {
  //       toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
  //     } else {
  //       toast.error("Request Failed", { autoClose: 3000 });
  //     }

  //     console.error("Error:", error); // Handle error as needed
  //   }
  // };

  // const rescind_trade_shift = async (shift_drop_id) => {
  //   // Prepare data to send
  //   const requestData = {
  //     store_id: storeId,
  //     shift_drop_id: shift_drop_id,
  //   };

  //   try {
  //     toast.loading("Cancelling Trade Request...", { autoClose: false });

  //     const res = await postRightworkAPI(API_rescind_drop_shift, requestData);

  //     if (res && res.status === 200) {
  //       // Handle success
  //       toast.dismiss();
  //       toast.success("Trade Request Cancelled!", { autoClose: 3000 });
  //       fetch_data(
  //         {
  //           shiftPool: API_get_shift_pool_for_manager,
  //           shiftPickupResponses:
  //             API_get_manager_shift_pickup_request_responses,
  //           schedule: API_get_schedule,
  //         },
  //         api_params
  //       );
  //     }
  //   } catch (error) {
  //     // Handle network error
  //     toast.dismiss();

  //     if (error.response?.data?.system?.message) {
  //       toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
  //     } else {
  //       toast.error("Request Failed", { autoClose: 3000 });
  //     }
  //     console.error("Error:", error); // Handle error as needed
  //   }
  // };

  const create_pickup_request = async (shift_drop_id) => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
      shift_drop_id: shift_drop_id,
    };

    try {
      toast.loading("Submitting Shift Pickup Request...", { autoClose: false });
      const res = await postRightworkAPI(API_pickup_shift, requestData);

      if (res && res.status === 200) {
        // Handle success
        toast.dismiss();
        toast.success("Shift Successfully Pickup Up!", { autoClose: 3000 });
        fetch_data(
          {
            shiftPool: API_get_shift_pool_for_manager,

            requestResponsesv2: API_get_manager_shift_change_request_responses
            // schedule: API_get_schedule,
          },
          api_params
        );
      }
    } catch (error) {
      // Handle network error
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
    }
  };

  // const rescind_pickup_shift = async (shift_drop_id) => {
  //   // Prepare data to send
  //   const requestData = {
  //     store_id: storeId,
  //     shift_drop_id: shift_drop_id,
  //   };

  //   try {
  //     toast.loading("Cancelling Shift Pickup Request...", { autoClose: false });

  //     const res = await postRightworkAPI(API_rescind_pickup_shift, requestData);

  //     if (res && res.status === 200) {
  //       // Handle success
  //       toast.dismiss();
  //       toast.success("Shift Pickup Request Cancelled!", { autoClose: 3000 });
  //       fetch_data(
  //         {
  //           shiftPool: API_get_shift_pool_for_manager,
  //           shiftPickupResponses:
  //             API_get_manager_shift_pickup_request_responses,
  //           schedule: API_get_schedule,
  //         },
  //         api_params
  //       );
  //     }
  //   } catch (error) {
  //     // Handle network error
  //     toast.dismiss();

  //     if (error.response?.data?.system?.message) {
  //       toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
  //     } else {
  //       toast.error("Request Failed", { autoClose: 3000 });
  //     }
  //     console.error("Error:", error); // Handle error as needed
  //   }
  // };

  const manager_reject_shift_drop = async (shift_drop_id) => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
      shift_drop_id: shift_drop_id,
    };

    try {
      toast.loading("Rejecting Shift Drop Request...", { autoClose: false });
      const res = await postRightworkAPI(
        API_manager_reject_shift_drop,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Shift Drop Request Rejected!", { autoClose: 3000 });
        fetch_data(
          {
            shiftPool: API_get_shift_pool_for_manager,
            // schedule: API_get_schedule,

            requestResponsesv2: API_get_manager_shift_change_request_responses
          },
          api_params
        );
        props.fetchBadgeCounts();
      }
    } catch (error) {
      // Handle network error
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
    }
  };

  const manager_accept_shift_drop = async (shift_drop_id, action) => {
    const requestData = {
      store_id: storeId,
      shift_drop_id: shift_drop_id,
      action: action,
    };

    try {
      toast.loading("Accepting Shift Drop Request...", { autoClose: false });
      const res = await postRightworkAPI(
        API_manager_accept_shift_drop,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Shift Drop Request Approved!", { autoClose: 3000 });
        fetch_data(
          {
            shiftPool: API_get_shift_pool_for_manager,

            requestResponsesv2: API_get_manager_shift_change_request_responses
          },
          api_params
        );
        props.fetchBadgeCounts();
      }
    } catch (error) {
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
    }
  };

  const manager_approve_shift_pickup = async (
    shift_change_request_uuid,
    response
  ) => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
      shift_change_request_uuid: shift_change_request_uuid,
      response: response,
    };

    try {
      toast.loading("Approving Shift Pickup Request...", { autoClose: false });
      const res = await postRightworkAPI(
        API_manager_approve_shift_pickup,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Shift Pickup Request Approved!", { autoClose: 3000 });
        fetch_data(
          {
            shiftPool: API_get_shift_pool_for_manager,
            // schedule: API_get_schedule,

            requestResponsesv2: API_get_manager_shift_change_request_responses
          },
          api_params
        );
        props.fetchBadgeCounts();
      }
    } catch (error) {
      // Handle network error
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
    }
  };

  const archive_shift_pickup_request = async (shift_change_request_uuid) => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
      shift_change_request_uuid: shift_change_request_uuid,
    };

    try {
      toast.loading("Archiving Shift Pickup Request...", { autoClose: false });
      const res = await postRightworkAPI(
        API_hide_shift_change_request,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Shift Pickup Request Archived!", { autoClose: 3000 });
        fetch_data(
          {

            requestResponsesv2: API_get_manager_shift_change_request_responses
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Request Failed", { autoClose: 3000 });
      console.error("Error:", error); // Handle error as needed
    }
  };

  const archive_trade_request = async (shift_change_request_uuid) => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
      shift_change_request_uuid: shift_change_request_uuid,
    };

    try {
      toast.loading("Archiving Trade Request...", { autoClose: false });
      const res = await postRightworkAPI(
        API_hide_shift_change_request,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Trade Request Archived!", { autoClose: 3000 });
        fetch_data(
          {

            requestResponsesv2: API_get_manager_shift_change_request_responses
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Request Failed", { autoClose: 3000 });
      console.error("Error:", error); // Handle error as needed
    }
  };

  // This function has been deprecated but is still being passed down
  const manager_shift_pickup_request_response = async (
    shift_pickup_request_uuid,
    response
  ) => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
      shift_pickup_request_uuid: shift_pickup_request_uuid,
      response: response,
    };

    try {
      toast.loading("Responding to Shift Pickup Request...", {
        autoClose: false,
      });
      const res = await postRightworkAPI(
        API_manager_shift_pickup_request_response,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Shift Pickup Request Response Successful!", {
          autoClose: 3000,
        });
        fetch_data(
          {
            shiftPool: API_get_shift_pool_for_manager,
            // schedule: API_get_schedule,

            requestResponsesv2: API_get_manager_shift_change_request_responses
          },
          api_params
        );
      }
    } catch (error) {
      // Handle network error
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
    }
  };

  const create_availability_request = async (data) => {
    /*
    store_id = request.data.get('store_id')
    dow = request.data.get('dow')
    available_from = request.data.get('available_from')
    available_to = request.data.get('available_to')
    note = request.data.get('note')
    user_id = request.user.id
    */

    // Prepare data to send
    const requestData = requestPayload(data, storeId);

    try {
      toast.loading("Creating Availability Request...", { autoClose: false });
      const res = await postRightworkAPI(
        API_create_availability_request,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success(requestDestinationMessage(requestData, storeId, props.storeNames), { autoClose: 3000 });
        fetch_data(
          {
            availability2: API_list_availability_for_employee,
            availabilityRequestsResponses:
              API_list_availability_request_responses_for_manager,
          },
          api_params
        );
      }
    } catch (error) {
      // Handle network error
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
    }
  };

  // Rescind availability request
  const rescind_availability_request = async (
    default_availability_request_id
  ) => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
      default_availability_request_id: default_availability_request_id,
    };

    try {
      toast.loading("Rescinding Availability Request...", { autoClose: false });
      const res = await postRightworkAPI(
        API_rescind_availability_request,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Availability Request Deleted!", { autoClose: 3000 });
        fetch_data(
          {
            availability2: API_list_availability_for_employee,
            availabilityRequestsResponses:
              API_list_availability_request_responses_for_manager,
          },
          api_params
        );
      }
    } catch (error) {
      // Handle network error
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
    }
  };

  const archive_availability_request = async (
    default_availability_request_id
  ) => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
      default_availability_request_id: default_availability_request_id,
    };

    try {
      toast.loading("Archiving Availability Request...", { autoClose: false });
      const res = await postRightworkAPI(
        API_hide_availability_request,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Availability Request Archived!", { autoClose: 3000 });
        fetch_data(
          {
            availability2: API_list_availability_for_employee,
            availabilityRequestsResponses:
              API_list_availability_request_responses_for_manager,
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Request Failed", { autoClose: 3000 });
      console.error("Error:", error); // Handle error as needed
    }
  };

  const create_blackout_date = async (date, reason) => {
    // Prepare data to send
    let requestData = {
      store_id: storeId,
      date: date,
      reason: reason,
    };

    try {
      toast.loading("Creating Blackout Date...", { autoClose: false });
      const res = await postRightworkAPI(API_create_blackout_date, requestData);

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Blackout Date Created!", { autoClose: 3000 });
        // fetch_data(
        //   {
        //     blackoutDates: API_get_blackout_dates,
        //   },
        //   api_params
        // );
      }
    } catch (error) {
      // Handle network error
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
      fetch_data(
        {
          blackoutDates: API_get_blackout_dates,
        },
        api_params
      );
    }
  };

  const delete_blackout_date = async (date) => {
    // Prepare data to send
    let requestData = {
      store_id: storeId,
      date: date,
    };

    try {
      toast.loading("Deleting Blackout Date...", { autoClose: false });
      const res = await postRightworkAPI(API_delete_blackout_date, requestData);

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Blackout Date Deleted!", { autoClose: 3000 });
        // fetch_data(
        //   {
        //     blackoutDates: API_get_blackout_dates,
        //   },
        //   api_params
        // );
      }
    } catch (error) {
      // Handle network error
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
      fetch_data(
        {
          blackoutDates: API_get_blackout_dates,
        },
        api_params
      );
    }
  };

  // Rescind time off request
  const rescind_time_off_request = async (time_off_request_uuid) => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
      time_off_request_uuid: time_off_request_uuid,
    };

    try {
      toast.loading("Rescinding Time Off Request...", { autoClose: false });
      const res = await postRightworkAPI(
        API_rescind_time_off_request,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Time Off Request Deleted", { autoClose: 3000 });
        fetch_data(
          {
            timeOff: API_get_list_time_off_requests_for_manager,
          },
          api_params
        );
      }
    } catch (error) {
      // Handle network error
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
    }
  };

  const archive_time_off_request = async (time_off_request_uuid) => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
      time_off_request_uuid: time_off_request_uuid,
    };

    try {
      toast.loading("Archiving Time Off Request...", { autoClose: false });
      const res = await postRightworkAPI(
        API_hide_time_off_request,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Time Off Request Archived!", { autoClose: 3000 });
        fetch_data(
          {
            timeOff: API_get_list_time_off_requests_for_manager,
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Request Failed", { autoClose: 3000 });
      console.error("Error:", error); // Handle error as needed
    }
  };

  const request_time_off = async (data) => {
    // Prepare data to send
    const requestData = requestPayload(data, storeId);

    try {
      toast.loading("Requesting Time Off...", { autoClose: false });
      const res = await postRightworkAPI(API_request_time_off, requestData);

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success(requestDestinationMessage(requestData, storeId, props.storeNames), { autoClose: 3000 });
        fetch_data(
          {
            timeOff: API_get_list_time_off_requests_for_manager,
          },
          api_params
        );
      }
    } catch (error) {
      // Handle network error
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
    }
  };

  const manager_respond_to_availability_request = async (
    request_id,
    response,
    note
  ) => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
      default_availability_request_id: request_id,
      response: response,
      note: note,
    };

    try {
      toast.loading("Responding to Availability Request...", {
        autoClose: false,
      });
      const res = await postRightworkAPI(
        API_manager_respond_to_availability_request,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Availability Request Response Successful!", {
          autoClose: 3000,
        });
        fetch_data(
          {
            availability2: API_list_availability_for_employee,
            availabilityRequests: API_list_availability_requests_for_manager,
            availabilityRequestsResponses:
              API_list_availability_request_responses_for_manager,
          },
          api_params
        );
        props.fetchBadgeCounts();
      }
    } catch (error) {
      // Handle network error
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
    }
  };

  const respond_to_time_off_request = async (request_uuid, response, note) => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
      time_off_request_uuid: request_uuid,
      status: response,
      note,
    };

    try {
      toast.loading("Responding to Time Off Request...", { autoClose: false });
      const res = await postRightworkAPI(
        API_respond_to_time_off_request,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Time Off Request Response Successful!", {
          autoClose: 3000,
        });
        fetch_data(
          {
            timeOff: API_get_list_time_off_requests_for_manager,
          },
          api_params
        );
        props.fetchBadgeCounts();
      }
    } catch (error) {
      // Handle network error
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
    }
  };

  const archive_drawer_notification = async (drawer_notification_uuid) => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
      drawer_notification_uuid: drawer_notification_uuid,
    };

    try {
      toast.loading("Archiving Drawer Notification...", { autoClose: false });
      const res = await postRightworkAPI(
        API_hide_drawer_notification,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Drawer Notification Archived!", { autoClose: 3000 });
        fetch_data(
          {
            notifications: API_drawer_notifications,
          },
          api_params
        );
        // Further handle success case as per your requirement
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Request Failed", { autoClose: 3000 });
      console.error("Error:", error); // Handle error as needed
    }
  };

  const archive_all_drawer_notifications = async () => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
    };

    try {
      toast.loading("Archiving All Drawer Notifications...", {
        autoClose: false,
      });

      const res = await postRightworkAPI(
        API_hide_all_drawer_notifications,
        requestData
      );

      if (res.status === 200) {
        // Handle success
        toast.success("All notifications were cleared successfully", {
          autoClose: 3000,
        });
        toast.dismiss();
        fetch_data(
          {
            notifications: API_drawer_notifications,
          },
          api_params
        );
      }
    } catch (error) {
      // Handle network error
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      fetch_data(
        {
          notifications: API_drawer_notifications,
        },
        api_params
      );
      console.error("Error:", error); // Handle error as needed
    }
  };

  const update_notification_settings = async (
    fe_settings,
    role_filter,
    apply_to_all_stores = false
  ) => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
      fe_settings: JSON.stringify(fe_settings),
      apply_to_all_stores: apply_to_all_stores ? "true" : "false",
    };
    if (role_filter !== undefined) {
      requestData.role_filter = JSON.stringify(role_filter);
    }

    try {
      toast.loading("Updating Notification Settings...", { autoClose: false });

      const res = await postRightworkAPI(
        API_update_notification_settings,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        fetch_data(
          {
            notificationSettings: API_get_notification_settings,
          },
          api_params
        );
        const appliedToAllStores =
          res?.data?.redux?.payload?.applied_to_all_stores;
        toast.success(
          appliedToAllStores
            ? "Notification settings updated across all your stores"
            : "Your notification settings were successfully updated",
          { autoClose: 3000 }
        );
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      fetch_data(
        {
          notificationSettings: API_get_notification_settings,
        },
        api_params
      );
      console.error("Error:", error); // Handle error as needed
    }
  };

  const hide_store_team_member = async (store_team_member_id, hidden) => {
    // Prepare data to send
    const requestData = {
      store_team_member_id: store_team_member_id,
      hidden: hidden,
    };

    try {
      toast.loading("Updating Employee...", { autoClose: false });
      const res = await postRightworkAPI(
        API_store_team_member_set_hide,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        const futureShiftCount =
          res.data?.redux?.payload?.future_shift_count;
        if (futureShiftCount && hidden === "true") {
          const confirmDelete = window.confirm(
            `This team member has ${futureShiftCount} upcoming shift${futureShiftCount === 1 ? "" : "s"}. Delete them?`
          );
          if (confirmDelete) {
            toast.loading("Deleting Shifts...", { autoClose: false });
            await postRightworkAPI(API_store_team_member_set_hide, {
              ...requestData,
              delete_shifts: "true",
            });
            toast.dismiss();
          }
        }

        toast.success("Employee Updated Successfully!", { autoClose: 3000 });
        fetch_data(
          {
            users: API_get_list_users,
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Request Failed", { autoClose: 3000 });
      console.error("Error:", error); // Handle error as needed
    }
  };

  const store_team_member_set_order = async (store_team_member_settings) => {
    // Prepare data to send
    const requestData = {
      store_id: storeId,
      store_team_member_settings: JSON.stringify(store_team_member_settings),
    };

    try {
      toast.loading("Setting Employees Order...", { autoClose: false });
      const res = await postRightworkAPI(
        API_store_team_member_set_order,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Order Set Successfully!", { autoClose: 3000 });
        fetch_data(
          {
            users: API_get_list_users,
          },
          api_params
        );
        // Further handle success case as per your requirement
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Request Failed", { autoClose: 3000 });
      console.error("Error:", error); // Handle error as needed
    }
  };

  React.useEffect(() => {
    // Fire both phases in parallel — Phase 1 renders Shift Pool as soon as it resolves
    fetch_data(phase1_api_calls, api_params, true);
    fetch_data(phase2_api_calls, api_params, false);
  }, [props.homeStore]);

  // Refresh targeted data when Operations Assistant confirms an action.
  // Skip on initial mount — phase1/phase2 already fetch everything.
  const opsRefreshMountedRef = React.useRef(false);
  React.useEffect(() => {
    if (!opsRefreshMountedRef.current) {
      opsRefreshMountedRef.current = true;
      return;
    }
    if (!props.opsRefreshSignal) return;
    const { types } = props.opsRefreshSignal;
    const refreshMap = {
      time_off: {
        timeOff: API_get_list_time_off_requests_for_manager,
        blackoutDates: API_get_blackout_dates,
      },
      shift: {
        shiftPool: API_get_shift_pool_for_manager,
        requestResponsesv2: API_get_manager_shift_change_request_responses,
        schedule: API_get_schedule,
      },
      availability: {
        availability2: API_list_availability_for_employee,
        availabilityRequests: API_list_availability_requests_for_manager,
        availabilityRequestsResponses: API_list_availability_request_responses_for_manager,
      },
      employees: {
        users: API_get_list_users,
      },
    };
    const merged = {};
    types.forEach((type) => Object.assign(merged, refreshMap[type]));
    if (Object.keys(merged).length > 0) {
      fetch_data(merged, api_params, false);
    }
  }, [props.opsRefreshSignal]);

  const userData = data.users?.redux?.payload?.employees;
  const myId = React.useMemo(() => {
    const scheduleId = data.schedule?.redux?.payload?.me?.store_team_member?.id;
    if (scheduleId) {
      return scheduleId;
    }
    const membership = props.storeOptions?.find(
      (member) => member.store === props.homeStore
    );
    return membership?.id;
  }, [data.schedule, props.storeOptions, props.homeStore]);
  const scheduleData = data.schedule?.redux?.payload?.schedule;
  const shiftPoolData = data.shiftPool?.redux?.payload?.schedule;
  const availabilityRequests = data.availabilityRequests?.redux?.payload;
  const preferencesRequests = data.preferencesRequests?.redux?.payload;
  const timeOffData = data.timeOff?.redux?.payload?.timeOffRequests;
  const minEffectiveDate = props.requestMinimumDaysInAdvance
    ? new Date(
        new Date().setDate(
          new Date().getDate() + props.requestMinimumDaysInAdvance
        )
      )
    : getMaxDatePlusOne(scheduleData);

  const timeOffRequests = timeOffData?.filter((v, i) => v.status === "PENDING");

  const shiftPoolRequests = shiftPoolData?.filter(
    (v, i) => v.status !== "PENDING_TRADE"
  );

  const tradeRequests = shiftPoolData?.filter(
    (v) => v.status === "PENDING_TRADE" && v.pending_pickups.length > 0
  );

  let notMyUpcomingShifts = [];
  if (scheduleData) {
    notMyUpcomingShifts = scheduleData.filter((shift) => {
      // Include the item if its date is today or in the future
      return (
        (shift.date >= formatDate(currentDate)) &
        (shift.store_team_member?.id !== myId)
      );
    });
  }

  const notifications =
    data.notifications?.redux?.payload?.drawer_notifications;

  const [isDrawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const blackoutDates = data?.blackoutDates?.redux?.payload?.blackoutDates;

  const roleNames = data?.roleNames


  return (
    <RequestLocationProvider stores={props.storeNames} memberships={props.storeOptions} currentStoreId={storeId}>
      {!isLoading ? (
        <div className="relative">
          <div className="w-full min-h-screen flex">
            <div className="w-1/5">
              <div className="h-full flex flex-col gap-2 px-6 py-5 bg-slate-50 border-r border-slate-200">
                <button
                  className={`mt-5 w-full py-3 px-4 text-left text-base flex items-center relative rounded-2xl ${
                    display === "Shift Pool" ? "bg-white" : ""
                  }`}
                  data-help-id="requests-subtab-shift-pool"
                  onClick={() => setDisplay("Shift Pool")}
                >
                  <div
                    className={`flex flex-1 items-center space-x-4 ${
                      display === "Shift Pool"
                        ? "text-violet-700"
                        : "text-slate-500"
                    }`}
                  >
                    <div>
                      <WavesIcon />
                    </div>
                    <span>Shift Pool</span>
                  </div>
                  {shiftPoolRequests?.length > 0 && (
                    <span className="text-slate-500 rounded-full flex items-center justify-center text-sm">
                      {shiftPoolRequests?.length}
                    </span>
                  )}
                </button>
                <button
                  className={`w-full py-3 px-4 text-left flex items-center relative rounded-2xl ${
                    display === "Trades" ? "bg-white" : ""
                  }`}
                  data-help-id="requests-subtab-trades"
                  onClick={() => setDisplay("Trades")}
                >
                  <div
                    className={`flex flex-1 items-center space-x-4 ${
                      display === "Trades"
                        ? "text-violet-700"
                        : "text-slate-500"
                    }`}
                  >
                    <div>
                      <SwapHorizIcon />
                    </div>
                    <span>Trades</span>
                  </div>
                  {tradeRequests?.length > 0 && (
                    <span className="text-slate-500 rounded-full flex items-center justify-center text-sm">
                      {tradeRequests?.length}
                    </span>
                  )}
                </button>
                <button
                  className={`w-full py-3 px-4 text-left flex items-center relative rounded-2xl ${
                    display === "Availability" ? "bg-white" : ""
                  }`}
                  data-help-id="requests-subtab-availability"
                  onClick={() => setDisplay("Availability")}
                >
                  <div
                    className={`flex flex-1 items-center space-x-4 ${
                      display === "Availability"
                        ? "text-violet-700"
                        : "text-slate-500"
                    }`}
                  >
                    <div>
                      <BackHandOutlinedIcon />
                    </div>
                    <span>Availability</span>
                  </div>
                  {availabilityRequests?.pending?.length > 0 && (
                    <span className="text-slate-500 rounded-full flex items-center justify-center text-sm">
                      {availabilityRequests?.pending?.length}
                    </span>
                  )}
                </button>
                <button
                  className={`w-full py-3 px-4 text-left flex items-center relative rounded-2xl ${
                    display === "Time Off" ? "bg-white" : ""
                  }`}
                  data-help-id="requests-subtab-time-off"
                  onClick={() => setDisplay("Time Off")}
                >
                  <div
                    className={`flex flex-1 items-center space-x-4 ${
                      display === "Time Off"
                        ? "text-violet-700"
                        : "text-slate-500"
                    }`}
                  >
                    <div>
                      <ScheduleOutlinedIcon />
                    </div>
                    <span>Time Off</span>
                  </div>
                  {timeOffRequests?.length > 0 && (
                    <span className="text-slate-500 rounded-full flex items-center justify-center text-sm">
                      {timeOffRequests?.length}
                    </span>
                  )}
                </button>
              </div>
            </div>
            <div className="w-4/5">
              <div>
                <TopBarDisplayTitle
                  title={display}
                  storeOptions={props.storeOptions}
                  homeStore={props.homeStore}
                  storeNames={props.storeNames}
                  change_home_store={props.change_home_store}
                />
              </div>
              {display === "Shift Pool" ? (
                <ShiftPoolDisplay
                  shiftPoolData={data.shiftPool?.redux?.payload?.schedule}
                  requestResponsesData2={data?.requestResponsesv2?.redux?.payload}
                  create_pickup_request={create_pickup_request}
                  manager_reject_shift_drop={manager_reject_shift_drop}
                  manager_accept_shift_drop={manager_accept_shift_drop}
                  manager_approve_shift_pickup={manager_approve_shift_pickup}
                  manager_shift_pickup_request_response={
                    manager_shift_pickup_request_response
                  }
                  archive_shift_pickup_request={archive_shift_pickup_request}
                />
              ) : display === "Trades" ? (
                <TradesDisplay
                  shiftPoolData={data.shiftPool?.redux?.payload?.schedule}
                  requestResponsesData2={data?.requestResponsesv2?.redux?.payload}
                  manager_reject_shift_drop={manager_reject_shift_drop}
                  manager_approve_shift_pickup={manager_approve_shift_pickup}
                  manager_shift_pickup_request_response={
                    manager_shift_pickup_request_response
                  }
                  archive_trade_request={archive_trade_request}
                  roleNames={roleNames}
                />
              ) : display === "Availability" ? (
                data.availability2 && data.availabilityRequests && data.availabilityRequestsResponses ? (
                  <AvailabilityDisplay
                    availabilityData2={data.availability2?.redux?.payload}
                    availabilityRequests={
                      data.availabilityRequests?.redux?.payload
                    }
                    availabilityRequestsResponses={
                      data.availabilityRequestsResponses?.redux?.payload
                    }
                    create_availability_request={create_availability_request}
                    archive_availability_request={archive_availability_request}
                    rescind_availability_request={rescind_availability_request}
                    manager_respond_to_availability_request={
                      manager_respond_to_availability_request
                    }
                    permissionRole={props.permissionRole}
                    minEffectiveDate={minEffectiveDate}
                    storeTimezone={storeTimezone}
                  />
                ) : (
                  <div className="w-full h-96 flex items-center justify-center">
                    <LoadSpinner />
                  </div>
                )
              ) : display === "Time Off" ? (
                data.timeOff ? (
                  <TimeOffDisplay
                    businessWeekStartDayIndex={getBusinessWeekStartDayIndex(props.storeNames, props.homeStore)}
                    timeOffData={data.timeOff?.redux?.payload?.timeOffRequests}
                    myId={myId}
                    request_time_off={request_time_off}
                    archive_time_off_request={archive_time_off_request}
                    rescind_time_off_request={rescind_time_off_request}
                    respond_to_time_off_request={respond_to_time_off_request}
                    minEffectiveDate={minEffectiveDate}
                    blackoutDates={blackoutDates}
                    create_blackout_date={create_blackout_date}
                    delete_blackout_date={delete_blackout_date}
                    canRequestPto={data.schedule?.redux?.payload?.me?.store_team_member?.can_request_pto}
                    canRequestSicktime={data.schedule?.redux?.payload?.me?.store_team_member?.can_request_sicktime}
                    storeTimezone={storeTimezone}
                  />
                ) : (
                  <div className="w-full h-96 flex items-center justify-center">
                    <LoadSpinner />
                  </div>
                )
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <LoadSpinner />
        </div>
      )}
      <NotificationsDrawer
        open={isDrawerOpen}
        onClose={toggleDrawer(false)}
        notifications={notifications}
        archive_drawer_notification={archive_drawer_notification}
        archive_all_drawer_notifications={archive_all_drawer_notifications}
        notificationSettings={data?.notificationSettings?.redux?.payload}
        update_notification_settings={update_notification_settings}
        permissionRole={props.permissionRole}
      />
    </RequestLocationProvider>
  );
}
